import React from 'react';
import cn from 'classnames';

import { ButtonStatus } from '../index';

import styles from './styles.module.scss';

interface Props extends React.HTMLAttributes<HTMLElement> {
  status?: ButtonStatus;
  className?: string;
  children?: React.ReactNode;
  onClick?(): void;
}

const Button: React.FC<Props> = props => {
  const { status = ButtonStatus.Normal, className, children, onClick, ...buttonProps } = props;

  const statusClass = {
    [ButtonStatus.Normal]: null,
    [ButtonStatus.Active]: styles.active,
    [ButtonStatus.Disabled]: styles.disabled,
  }[status];

  return (
        <div
            className={cn(styles.btn, statusClass, className)}
            onClick={onClick}
            {...buttonProps}
        >
            <div className={styles.children}>{children}</div>
        </div>
  );
};

export default Button;
